module.exports = __webpack_public_path__ + "static/media/nile-sunset.429ea202.mp4";